// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__HqJN5","requiredAsterisk":"Info_requiredAsterisk__36nl8"};